import { render, staticRenderFns } from "./videoConnection.vue?vue&type=template&id=5b0a179c&scoped=true&"
import script from "./videoConnection.vue?vue&type=script&lang=js&"
export * from "./videoConnection.vue?vue&type=script&lang=js&"
import style0 from "./videoConnection.vue?vue&type=style&index=0&id=5b0a179c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0a179c",
  null
  
)

export default component.exports